module.exports = __webpack_public_path__ + "img/background-large.11919338.png";